import type { Request } from '../../../../index'
import { SalePointCategoriesParams, SalePointCategories } from 'app/common/types/sale-points/categories'

type PathParamsDto = {
  school_id: number
  sale_point_id: number
}

type ResultDto = {
  categories_ids: Array<number>
  use_complexes: boolean
  limit_single_item_in_purchase?: number | null
}

export const convertParams = ({ orgId, salePointId }: SalePointCategoriesParams): [null, PathParamsDto] => [
  null,
  { school_id: orgId, sale_point_id: salePointId },
]

export const convertResult = ({ categories_ids, use_complexes, limit_single_item_in_purchase }: ResultDto): SalePointCategories => ({
  categoriesIds: categories_ids.map(id => id.toString()),
  useComplexes: use_complexes,
  limitSingleItemInPurchase: limit_single_item_in_purchase ?? null,
})

export const GET_SALE_POINT_CATEGORIES: Request<SalePointCategoriesParams, SalePointCategories, PathParamsDto> = [
  'food/schools/{school_id}/sale_points/{sale_point_id}/categories',
  'get',
  ['data'],
]
